import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'app-null',
    template: '',
    standalone: false
})
export class NullComponent extends FieldType {}
